import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
// RequestOptions
import { Config } from '../../config';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  constructor(private httpClient: HttpClient, private Config: Config) { }
  loadedProjectData: any = {};
  lastUpdatedDataModel: any = {};
  detailsArray: any = [];
  socketDetails: any = {};
  private subject = new Subject<any>();
  private subjectData = new Subject<any>();
  jiraProjectData: any = [];
  projectJsonSubject = new BehaviorSubject<any>(null);
  jiraProDataSubject = new BehaviorSubject<any>(null);

  projectDataLoad(data: any) {
    this.projectJsonSubject.next(data);
    this.loadedProjectData = data;
    this.lastUpdatedDataModel = data.model;
    localStorage.setItem(
      'lastUpdatedModel',
      JSON.stringify(this.lastUpdatedDataModel)
    );
    // console.log('loadedProjectData', this.loadedProjectData);
  }

  socketDetailsLoad(soc: any) {
    this.socketDetails = soc;
    // console.log('this.socketDetails ', this.socketDetails);
    // console.log('this.socketDetails', this.socketDetails.id);
  }
  updateProject(loadedProjectData: any) {
    const headers = {
      'Content-Type': 'application/json',
      Authorization: localStorage.getItem('publicToken') || '{}',
    };
    let params = new HttpParams();
    params = params.append('_id', loadedProjectData._id);
    const body = loadedProjectData;
    return this.httpClient
      .put(
        `${environment.baseUrl}${environment.port}${environment.baseUri}/project`,
        body,
        { headers, params }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  projectContent(data: any) {
    // console.log("data",data.listOfEUTs[0].eName);
    // console.log("data2",this.lastUpdatedDataModel.listOfEUTs[0].eName);
    if (JSON.stringify(data) != localStorage.getItem('lastUpdatedModel')) {
      this.updateProject(data).subscribe((response: any) => {
        // console.log('updateProject res', response);
        localStorage.setItem('lastUpdatedModel', JSON.stringify(data));
        // localStorage.setItem('projectID', response._id);
        // this.main.startSession(response, false, response._id);
        // this.projectOpen = true;
        // this.startSession(newProject, true, response._id);
        // var projectJSONwithID = newProject;
        // projectJSONwithID._id = response._id;
        // localStorage.setItem('projectID', response._id);
        // localStorage.setItem('projectName', response.projectDetails.name);
      });
    }
  }
  // function updateProject(project, record = false) {
  //   // console.log("update", project);
  //   var request = {
  //     method: 'PUT',
  //     url: appConst.request.project.url,
  //     params: {
  //       _id: project._id
  //     },
  //     headers: {
  //       'Content-Type': 'application/json'
  //     },
  //     data: project
  //   };

  //   return $http(request).then(function (response) {

  //     var updatedProject = response.data;

  //     switch (record) {
  //       case true:
  //         return addSession(updatedProject).then(function (session) {
  //           return session.project;
  //         });
  //         break;
  //       case false:
  //         return updatedProject;
  //         break;
  //     }
  //   });
  // }

  addAlldetails(detailsObj: any) {
    this.detailsArray.push(detailsObj);
    // console.log('add called!!!', detailsArray);
  }

  getAlldetails() {
    // console.log('get called!!!', detailsArray);
    return this.detailsArray;
  }

  triggerTool(entity: any) {
    this.subject.next(entity);
  }

  triggerActiveItem(entity: any) {
    this.subjectData.next(entity);
  }

  getClickEvent(): Observable<any> {
    return this.subject.asObservable();
  }

  getActiveData(): Observable<any> {
    return this.subjectData.asObservable();
  }
  loadJiraProjectData(jiraPro: any) {
    this.jiraProjectData = jiraPro;
    this.jiraProDataSubject.next(jiraPro);
  }
}
